/* global bocAmchart */


/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValetRelativeDateYear = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValetRelativeDateYear(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 * Produces and returns an array of data based on the valet data
 * Processes the dates as relative to 2000-01-01 00:00 and converts values to years
 *
 * @param {object} data Object containing the valet data sets
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValetRelativeDateYear = function (data, dataLoader, chart) {
    var output = [];
    var revisedText = bocAmchart.getRevisedText();

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    chart.categoryField = "date_year";
    chart.categoryAxis.parseDates = false;
    chart.categoryAxis.labelFunction = bocAmchart.roundNumber;
    chart.chartCursor.categoryBalloonFunction = bocAmchart.roundNumber;

    data.observations.forEach(function (set) {
        var dateSet = [];
        for (var property in set) {
            if (set.hasOwnProperty(property)) {
                if (property === 'd') {
                    var date = new Date(set.d + 'T00:00:00.000Z');

                    dateSet.date_year = parseFloat(
                        date.getUTCFullYear() - 2000 +
                        date.getUTCMonth() / 12 +
                        (date.getUTCDate() - 1) / 12 / 30
                    );

                } else {
                    dateSet[property] = set[property].v;
                    if (set[property].hasOwnProperty('r') && set[property].r === 1) {
                        dateSet[property + '_R'] = revisedText;
                    }
                }
            }
        }
        output.push(dateSet);
    });

    if ((!chart.hasOwnProperty("graphs") || chart.graphs.length === 0)
        && data.hasOwnProperty("seriesDetail")) {
        // Collect all the series available in the data
        var seriesSet = [];

        for (var prop in data.seriesDetail) {
            if (seriesSet.indexOf(prop) === -1) {
                bocAmchart.addGraph(
                    chart,
                    prop,
                    data.seriesDetail[prop].label
                );
            }
        }
    }

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "After doPostProcessValet, output:",
            output
        );
    }

    return output;
};

/**
 * Returns the number rounded to 2 significant digits
 *
 * @param {string} valueText input number string
 * @returns {string} adjusted number string
 */
bocAmchart.roundNumber = function (valueText) {
    if (!isNaN(valueText)) {
        valueText = parseFloat(valueText).toPrecision(2);
    }
    return valueText;
};
